import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { CATEGORY_SLUGS } from "../../util/page-language.util";

// the content category (its Dutch slug) for the slug of a category page in either language
export const SUPPORTED_CONTENT_CATEGORIES: Readonly<Record<string, string>> = Object.fromEntries(
    CATEGORY_SLUGS.flatMap(slugs => [[slugs.nl, slugs.nl], [slugs.en, slugs.nl]]));


@Component({
  standalone: false,
  selector: 'app-apps',
  templateUrl: './apps.component.html'
})
export class AppsComponent implements OnInit {

  contentCategory: string;
  language: string;

  constructor(private route: ActivatedRoute,
              private translate: TranslateService) {
  }

  async ngOnInit(): Promise<void> {
    this.language = this.translate.getCurrentLang();
    this.contentCategory = SUPPORTED_CONTENT_CATEGORIES[this.route.snapshot.params["category"]];
  }
}
